//@flow
import * as React from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import _ from 'lodash';
import { connect }  from 'react-redux';
import { withRouter } from 'react-router-dom';
import FullCustomCard from '../../components/FullCustomCard/FullCustomCard';
import TopoTitleComponente from '../../components/PageTitle/TopoTitleComponente';
import TopoListagem from '../../components/Topo/TopoListagem';
import { empresaService } from '../../_services/empresa.service';
import EmpresaForm from './EmpresaForm';
import ResponsavelForm from './ResponsavelForm';
import { objectsConstants } from '../../_constants/objects.constants';

const defaultArrayItem = [{ idList: new Date().getTime() }];
const defaultEntity: empresa = {
  nome: '',
  dominio: '',
  responsavel: {},
};

class EmpresaEdit extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.state = {
      entity: defaultEntity,
    };
  }

  goToViewEntity = (values) => {
    this.props.history.push({
      pathname: '/empresa/view/' + values.id,
      state: { entity: values },
    });
  };

  handleCancel = () => {
    this.props.history.goBack();
  };

  componentDidMount() {
    if (this.props.match.params.id) {
      this.props.loading(true);
      empresaService.doGet(this.props.match.params.id).then(
        (response) => {
          let empresa = response.data.data;
          if (_.get(empresa, 'responsavel')) {
            _.set(empresa, 'responsavel', {});
          }
          this.setState({ entity: empresa }, () => {
            this.props.loading(false);
          });
        },
        (error) => {
          console.log(error);
          this.props.loading(false);
        }
      );
    }
  }

  render() {
    const { entity } = this.state;
    const { ...otherPops } = this.props;
    return (
      <React.Fragment>
        {/* <div className="d-flex flex-column flex-xl-row justify-content-center"> */}
        <TopoTitleComponente
          mainTitle={`${entity.id ? 'Editar ' : 'Nova '}  empresa`}
          canBack={true}
          backUrl={!entity.id ? null : '/empresa'}
        />
        <TopoListagem
          showIndisponibilidade={false}
          showfilter={false}
        ></TopoListagem>

        <div className="flex-column mt-4">
          <FullCustomCard
            permissionSave={objectsConstants.MENU_CODE4}
            title="Empresa"
            Componente={EmpresaForm}
            viewMode={false}
            entity={entity}
            onCancel={this.handleCancel}
            {...otherPops}
          ></FullCustomCard>
          {entity.id && (
            <FullCustomCard
              permissionSave={objectsConstants.MENU_CODE4}
              title="Responsável pela empresa"
              Componente={ResponsavelForm}
              viewMode={true}
              entity={entity}
              {...otherPops}
            ></FullCustomCard>
          )}
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
  };
}

const mapDispatch = ({
  alert: { success, error, clear },
  load: { loading },
  authentication: { refreshUser },
}) => ({
  success: (msg) => success(msg),
  loading: (load: boolean) => loading({ load }),
  error: (msg) => error(msg),
  clear: () => clear(),
  refreshUser: (payload) => refreshUser(payload),
});

export default withRouter(
  connect(mapStateToProps, mapDispatch, null)(EmpresaEdit)
);
